import css from 'styled-jsx/css';
import { colors } from '../../../../config/styles';

const MobileCarouselPodStyles = css`
  .carousel__pod {
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: ${colors.white.shade1};
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.2s ease;
    width: 44%;
    flex-shrink: 0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .carousel__pod:hover .carousel__pod-image :global(img) {
    transform: scale(1.07);
    transition: transform 0.2s ease;
  }

  .carousel__pod-anchor {
    text-decoration: none;
    color: inherit;
    display: block;
    height: 100%;
  }

  .carousel__pod-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
  }

  .carousel__pod-layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    padding: 16px;
  }

  .carousel__pod-image {
    width: 100%;
    height: 200px;
    overflow: hidden;
    border-radius: 12px 12px 0 0;
    flex-shrink: 0;
    position: relative;
    margin: 0;
    padding: 0;
    display: block;
    border: none;
    box-sizing: border-box;

    @media (max-width: 767px) {
      height: 180px;
    }
  }

  .carousel__pod-image :global(img) {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  .carousel__pod-details {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
  }

  .carousel__pod-brand {
    font-size: 11px;
    font-weight: 600;
    color: ${colors.gray.shade40};
    line-height: 1.2;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin: 8px 0;
  }

  .carousel__pod-description {
    font-size: 14px;
    font-weight: 400;
    color: ${colors.gray.shade52};
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    letter-spacing: 0px;
    margin: 8px 0;
  }

  .carousel__pod-sponsored-label {
    font-size: 10px;
    font-weight: 400;
    color: ${colors.gray.shade40};
    text-transform: capitalize;
    letter-spacing: 0.2px;
    text-align: right;
    background-color: transparent;
    margin: 0;
  }

  .carousel__pod-rating {
    display: flex;
    align-items: center;
    margin: 8px 0;
  }

  .carousel__pod-price {
    display: flex;
    align-items: flex-start;
  }

  .carousel__pod-rating :global(.reviews) {
    font-size: 11px;
    color: ${colors.gray.shade40};
    white-space: nowrap;
    margin-left: 2px;
  }

  /* Desktop: Both visible on hover */
  @media (min-width: 1024px) {
    .carousel__pod-image {
      width: 100%;
      margin: 0;
      padding: 0;
      border-radius: 12px 12px 0 0;
    }

    .carousel__pod-image :global(img) {
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
    }
  }

  .badges-container {
    position: absolute;
    top: 14px;
    left: 14px;
    z-index: 2;
    display: flex;
    flex-direction: row;
    gap: 4px;
    max-width: calc(75% - 14px);
  }

  .badges-container :global(.badge-item) {
    max-width: 100%;
    font-size: 9px;
    padding: 2px 6px;
    border-radius: 3px;
  }

  .pod-actions {
    padding: 8px;
    border-top: 1px solid ${colors.gray.shade12};
    background-color: ${colors.gray.shade3};
  }

  @media (max-width: 767px) {
    .carousel-pod-layout {
      padding: 12px;
    }

    .pod-actions {
      padding: 8px;
    }
  }

  /* Tablet adjustments */
  @media (min-width: 768px) and (max-width: 1023px) {
    .carousel-pod-layout {
      padding: 10px;
    }
  }

  /* Desktop enhancements */
  @media (min-width: 1024px) {
    .carousel-pod-layout {
      padding: 12px;
    }
  }
`;

const Actions = css`
  .pod-actions {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export { Actions, MobileCarouselPodStyles };
